module.exports = __webpack_public_path__ + "media/images/smart_phone/ttl_gifu-92caf4d830fabd15039ea8b824614a6b.png";